exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.empty-text{margin-top:16px;font-family:Open Sans,sans-serif;font-size:18px;font-weight:600;font-style:italic;text-align:center;color:#ddd}.chronological-list{max-height:100%}.chronological-list .section-header{display:flex;background-color:#fff}.chronological-list .section-header__date{margin-top:27px;margin-left:11px;font-size:24px;font-family:Oswald,sans-serif;color:#d8d8d8;font-weight:300}.chronological-list .section-header__delete-all{margin:44px 24px 5px auto;font-family:Open Sans,sans-serif;font-size:12px;font-style:italic;color:#8b8b8b;text-decoration:underline;cursor:pointer}.chronological-list .section-header__underline{width:100%;margin:0;margin-top:2px;border:.5px solid #9b9b9b}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/ChronologicalItemList/ChronologicalItemList.scss
// module id = 1535
// module chunks = 0